module.exports = __webpack_public_path__ + "img/Mask Group 3.10fb690f.png";